<template>
    <div>
        <!-- Add template modal start-->
        <div id="proposalTypeModal" data-backdrop="static" data-keyboard="false" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg text-black">
                            {{ proposalTemplateModalTitle }}
                        </h4>
                        <button type="button" dusk="modal-close-button" @click="proposalTemplateCancel()"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="mb-2">
                                <div class="form-group">
                                    <label class="text-black font-light text-sm">Proposal Template Name</label>
                                    <input  class="form-control"
                                            type="text"
                                            v-model="proposalTemplateName"
                                            id="proposal_type_name">
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <div v-if="proposalTemplateModalButton == 'Save'">
                            <button name="cancel-proposal-template"
                                    @click="proposalTemplateCancel()"
                                    class="px-3 py-1 rounded-full text-teal focus:outline-none">
                                Cancel
                            </button>
                            <button id="save-proposal-type" name="save-proposal-template"
                                    @click="saveProposalTemplate()"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                {{ proposalTemplateModalButton }}
                            </button>
                        </div>
                        <div v-if="proposalTemplateModalButton == 'Update'">
                            <button name="cancel-proposal-template"
                                    @click="proposalTemplateCancel()"
                                    class="px-3 py-1 rounded-full text-teal focus:outline-none">
                                Cancel
                            </button>
                            <button  id="update-proposal-type" name="update-proposal-template"
                                    @click="updateProposalTemplate()"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                {{ proposalTemplateModalButton }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Add template modal end-->

        <div id="proposal-settings-template-div">
            <div class="row">
                <div class="col-md-6 float-left">
                    <h5>Proposal Templates</h5>
                </div>
                <div class="col-md-6 float-right text-right">
                    <input type="text" placeholder="Search Template" @keyup="fetchProposalTemplates()" class="form-control" id="searchTemplate" v-model="searchTemplateData">
                    <button id="add-proposal-template" name="add-proposal-template" @click="openAddTemplateModal()"
                            class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 text-white focus:outline-none rounded add-new-template-button">
                        New Proposal Template
                    </button>
                </div>
            </div>
            <div class="proposal-template-listing-div mt-3">
                <div class="proposal-template-listing-heading">
                    <div class="row proposal-template-listing-heading-row pt-2 pb-2 text-black">
                        <div class="col-md-5 float-left cursor-pointer" @click="sortByColumn('name')">
                            Proposal Name

                            <i class="fa fa-xs ml-2"
                               :class="{'fa-chevron-up' : currentOrder.direction === 'asc',
                                        'fa-chevron-down' : currentOrder.direction === 'desc'}"
                               v-if="currentOrder.sortBy === 'name'"></i>
                        </div>
                        <div class="col-md-5 float-left cursor-pointer" @click="sortByColumn('updated_at')">
                            Last Updated

                            <i class="fa fa-xs ml-2"
                               :class="{'fa-chevron-up' : currentOrder.direction === 'asc',
                                        'fa-chevron-down' : currentOrder.direction === 'desc'}"
                               v-if="currentOrder.sortBy === 'updated_at'"></i>
                        </div>
                        <div class="col-md-2 float-left">
                        </div>
                    </div>
                </div>
                <div class="proposal-template-listing">
                    <div v-if="proposalTemplates.length > 0">
                        <div class="row proposal-template-listing-row pt-2 pb-2 text-black" v-for="proposalTemplate in proposalTemplates" :id="'proposal-template-row-'+proposalTemplate.id">
                            <div class="col-md-5 float-left">
                                {{ proposalTemplate.name }}
                            </div>
                            <div class="col-md-5 float-left">
                                {{ proposalTemplateUpdateDate(proposalTemplate.updated_at) }}
                            </div>
                            <div class="col-md-2 float-left text-right">
                                <div class="dropdown open">
                                    <button type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                        <svg class="fill-current h-4 w-4" enable-background="new 0 0 515.555 515.555"
                                             viewBox="0 0 515.555 515.555" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="m303.347 18.875c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                            <path
                                                d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                            <path
                                                d="m303.347 405.541c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                        </svg>
                                    </button>

                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" @click="manageTemplate(proposalTemplate)">Manage</a>
                                        <a class="dropdown-item" @click="settingsTemplate(proposalTemplate)">Settings</a>
                                        <a class="dropdown-item" @click="renameTemplateModal(proposalTemplate)">Rename</a>
                                        <a class="dropdown-item" @click="duplicateTemplate(proposalTemplate)">Duplicate</a>
                                        <a class="dropdown-item" @click="deleteTemplate(proposalTemplate)">Delete</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <h5 class="text-black text-center mt-4">
                            {{ proposalListingText }}
                        </h5>
                    </div>
                    <div v-if="pagination.total > pagination.per_page" class="flex justify-center mt-3">
                        <b-pagination
                            @change="goToPage"
                            v-model="pagination.current_page"
                            :total-rows="pagination.total"
                            :per-page="pagination.per_page"
                            first-text="First"
                            prev-text="Prev"
                            next-text="Next"
                            last-text="Last"
                        >
                        </b-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";

export default {
    name: "proposal-settings-templates",
    props:[],
    components: {},
    data() {
        return {
            proposalTemplates:[],
            proposalListingText: 'Loading Proposal Templates',
            page: 1,
            pagination: {
                data: [],
                meta: {},
                links: {},
            },
            proposalTemplateModalTitle:'Manage Proposal Template Name',
            proposalTemplateName:'',
            proposalTemplateModalButton:'Save',
            selectedTemplate:null,
            searchTemplateData:'',
            currentOrder:{
                direction:'',
                sortBy:''
            }
        }
    },
    mounted(){
        this.fetchProposalTemplates();
    },
    methods: {
        fetchProposalTemplates(){
            if(this.page !== 1 && this.searchTemplateData.trim() !== ''){
                this.page = 1;
            }
            axios.get(route('api.proposal-templates.list', {page: this.page, search:this.searchTemplateData.trim(), sort:this.currentOrder})).then((response) => {
                let data = response.data;
                    if(data.data.length > 0){
                        this.proposalTemplates = data.data;
                        this.pagination = data;
                    }else{
                        this.proposalTemplates = [];
                        this.proposalListingText = 'No proposal template found';
                        this.pagination = data;
                    }
            });
        },
        proposalTemplateUpdateDate(updatedAt){
            return moment.utc(updatedAt).local().format('MM/DD/YYYY hh:mm A')
        },
        goToPage(page) {
            this.page = page;
            this.$nextTick(()=>{
                this.fetchProposalTemplates();
            });
        },
        openAddTemplateModal(){
            $('#proposalTypeModal').modal('show');
        },
        proposalTemplateCancel(){
            this.proposalTemplateModalTitle = 'Manage Proposal Template Name';
            $('#proposalTypeModal').modal('hide');
            this.proposalTemplateName = '';
            this.proposalTemplateModalButton = 'Save';
            this.selectedTemplate = null;
        },
        saveProposalTemplate(){
            if(this.proposalTemplateName.trim() == '' || this.proposalTemplateName == null){
                this.getToast().fire({
                    type: 'success',
                    title: 'Please enter template name.'
                });
                this.proposalTemplateName = '';
                return false;
            }
            axios.post(route('api.proposal-type.store'), {name:this.proposalTemplateName}).then(({data}) => {
                if(data.status == 'success'){
                    this.getToast().fire({
                        type: 'success',
                        title: data.message
                    });
                    this.page = 1;
                    this.fetchProposalTemplates();
                    this.proposalTemplateCancel();
                }else{
                    this.getToast().fire({
                        type: 'success',
                        title: data.message
                    });
                }
            });
        },
        updateProposalTemplate(){
            if(this.proposalTemplateName.trim() == '' || this.proposalTemplateName == null){
                this.fireErrorToast('Please enter template name.');
                this.proposalTemplateName = '';
                return false;
            }

            if(this.proposalTemplateName.trim() == this.selectedTemplate.name){
                $('#proposalTypeModal').modal("hide");
                this.proposalTemplateModalTitle = 'Manage Proposal Template Name';
                this.proposalTemplateModalButton = 'Save';
                this.proposalTemplateName = '';
                return false;
            }

            axios.post(route('api.proposal-type.update'), {name:this.proposalTemplateName, proposalType:this.selectedTemplate}).then(({data}) => {
                if(data.status == 'success'){
                    this.getToast().fire({
                        type: 'success',
                        title: data.message
                    });
                    this.page = 1;
                    this.fetchProposalTemplates();
                    this.proposalTemplateCancel();
                }else{
                    this.getToast().fire({
                        type: 'error',
                        title: data.message
                    });
                }
            });
        },
        renameTemplateModal(template){
            this.proposalTemplateModalButton = 'Update';
            this.proposalTemplateModalTitle = 'Rename Template'
            this.proposalTemplateName = template.name;
            this.selectedTemplate = template;
            $('#proposalTypeModal').modal('show');
        },
        deleteTemplate(template){
            Swal.fire({
                title             : "Are you sure?",
                text              : "Once deleted, you will not be able to recover this proposal template!",
                icon              : "warning",
                buttons           : true,
                showCancelButton  : true,
                confirmButtonColor: 'red',
                confirmButtonText : 'I\'m sure!',
                closeOnConfirm    : true,
                closeOnCancel     : true,
            }).then(result => {
                if (result.value) {
                    axios.post(route('api.proposal-type.delete'), {proposalType: template}).then((data) => {
                        if(data.data.status == 'success'){
                            this.getToast().fire({
                                type: 'success',
                                title: data.data.message
                            });
                            this.page = 1;
                            this.fetchProposalTemplates();
                        }else{
                            this.getToast().fire({
                                type: 'error',
                                title: data.message
                            });
                        }
                    });
                }
            });
        },
        manageTemplate(template){
            Bus.$emit('changeSettingType', {selectedData: template, type:'template-manage'});
        },
        duplicateTemplate(template){
            axios.post(route('api.proposal-templates.duplicate'), {template: template}).then((response) => {
                if(response.data.status == 'success'){
                    this.fetchProposalTemplates();
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                }
            });
        },
        sortByColumn(sortBy){
            if(this.currentOrder.direction == 'desc'){
                this.currentOrder = {
                    'direction':'asc',
                    'sortBy':sortBy
                };
            }else{
                this.currentOrder = {
                    'direction':'desc',
                    'sortBy':sortBy
                };
            }
            this.fetchProposalTemplates();
        },
        settingsTemplate(template){
            Bus.$emit('changeSettingType', {selectedData: template, type:'template-settings'});
        }
    }
};
</script>

<style>
#proposal-settings-template-div {
    padding: 5px 0;
}
#proposal-settings-template-div h5{
    color: #222;
    font-weight: 400;
    padding: 5px 0px;
}
#proposal-settings-template-div .add-new-template-button{
    height: 40px;
    font-weight: 300;
}
.proposal-template-listing-heading-row{
    background: #f4f5f6;
    font-weight: 500;
}
.proposal-template-listing-row {
    font-weight: 300;
}
.proposal-template-listing-row .dropdown-item {
    font-weight: 300;
    font-size: 15px;
}
.proposal-template-listing-row:hover {
    background: #f5f5f5;
}
input#searchTemplate {
    float: left;
    width: 55%;
}
</style>
